module.exports = __webpack_public_path__ + "img/trophy-icon.edf7eba7.svg";